import React, { useEffect } from "react"
import withStyles from "react-jss"
import "./RangeSlider.css"

const styles = {
  slidersControl: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  slideInput: {
    //width: "100%"
  },
}

const RangeSlider = ({ classes, rankValue }) => {
  let rank = (rankValue && parseInt(rankValue.replace(/[^0-9]/g, ""))) || 0

  let val1 = 0,
    val2 = 0
  if (rank) {
    if (rank <= 27000) {
      val1 = rank
    } else {
      val2 = rank
    }
  }

  return (
    <div className="rangeContainer">
      <div className={classes.slidersControl}>
        <input
          className={
            classes.slideInput + " rangeOne" + (!val1 ? " val1Hide" : "")
          }
          type="range"
          max="27000"
          min="0"
          step="1"
          value={val1}
          readOnly
          tabIndex="-1"
          aria-hidden="true"
        />
        <span className="break"></span>
        <input
          className={
            classes.slideInput + " rangeTwo" + (!val2 ? " val2Hide" : "")
          }
          type="range"
          max="40000"
          min="27000"
          step="1"
          value={val2}
          readOnly
          tabIndex="-1"
          aria-hidden="true"
        />
      </div>
    </div>
  )
}

export default withStyles(styles)(RangeSlider)
